import { useEffect, useState } from "react";
import { announementsData } from "../../assets/announcements";
import { FaRegComment } from "react-icons/fa";
import { MdDateRange } from "react-icons/md";
import { useNavigate } from "react-router-dom";
export default function AnnounementsList() {
  const [announcements, setAnnouncements] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    setAnnouncements(announementsData);
  }, []);
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <>
      <h1
        tabIndex="0"
        className="uppercase focus:outline-none text-base sm:text-lg md:text-xl lg:text-2xl font-bold leading-normal text-gray-800"
      >
        Announements List
      </h1>

      <div className="space-y-4 mt-8">
        {announcements?.map((announcement, index) => (
          <div
            key={index}
            className=" p-2 rounded-lg w-full  bg-gray-200 border-2 border-gray-500 hover:cursor-pointer hover:text-blue-500 hover:border-blue-400"
            onClick={() => {
              navigate(`/dashboard/${user.role.toLowerCase()}/announcement`, {
                state: { id: announcement._id },
              });
            }}
          >
            <h1 className="text-xl font-medium mb-2">{announcement.title}</h1>
            <div className="flex justify-between py-1">
              <p className="flex flex-row items-center justify-between gap-1">
                <MdDateRange className="w-4 h-4" /> {announcement?.date}
              </p>
              <p className="flex flex-row items-center justify-between gap-1">
                <FaRegComment className="w-4 h-4" />{" "}
                {announcement?.comments?.length}
              </p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
